import React, { useContext, useState } from "react";
import { Redirect } from "react-router";
import { Alert, notification } from "antd";
import { ILoginDetails, IResetPasswordModel } from "@Models/ILoginDetails";
import SessionManager from "@Core/session";
import "@Styles/main.scss";
import AccountService from "@Services/AccountService";
import PasswordResetRequestForm from "@Components/account/PasswordResetRequestForm";
import LoginForm from "@Components/account/LoginForm";
import PageHelmet from "@Components/shared/PageHelmet";
import { MainContext } from "@Context/provider";
import { ViewMode } from "@Context/state";

const LoginPage: React.FC = (props) => {
    const [resetPass, setResetPass] = useState<boolean>(false);
    const [resetMessage, setResetMessage] = useState<boolean>(false);
    const [loginSuccess, setLoginSuccess] = useState(false);
    const [fetching, setFetching] = useState<boolean>(false);
    const { ui: uiState, setCachedPath } = useContext(MainContext);
    const isDesktop = uiState.mode === ViewMode.desktop;

    const onSubmit = async (data: ILoginDetails) => {
        setFetching(true);
        const service = new AccountService();
        const result = await service.login(data);
        setFetching(false);
        if (!result.hasErrors) {
            setLoginSuccess(true);
        } else {
            notification.error({ message: result.errors.toString() });
        }
    };

    const onResetSubmit = async (data: IResetPasswordModel) => {
        setFetching(true);
        const service = new AccountService();
        await service.reset(data);
        setResetPass(false);
        setResetMessage(true);
        setFetching(false);
    };

    const onResetPasswordSelect = () => {
        setResetPass(true);
    };

    const onBackSelect = () => {
        setResetPass(false);
    };

    if (SessionManager.isAuthenticated && loginSuccess) {
        const path = uiState.cachedPath ?? "";
        if (path !== "") {
            setCachedPath(null);
            return <Redirect to={path} />;
        }
        return <Redirect to="/" />;
    }

    return (
        <section
            id="login-page"
            style={
                isDesktop
                    ? { display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center" }
                    : null
            }
        >
            <PageHelmet name={"Login"} />

            <div className="login-form">
                {!resetPass ? (
                    <LoginForm
                        {...props}
                        onSubmit={onSubmit}
                        onResetPassword={onResetPasswordSelect}
                        fetching={fetching}
                    />
                ) : (
                    <PasswordResetRequestForm
                        {...props}
                        onResetSubmit={onResetSubmit}
                        onBackSelect={onBackSelect}
                        fetching={fetching}
                    />
                )}
            </div>
            {resetMessage && (
                <>
                    <div className={"spacer"}>&nbsp;</div>
                    <Alert
                        message={"Thanks. We've sent a password reset to the email you've provided."}
                        type="info"
                        showIcon
                    />
                </>
            )}
        </section>
    );
};

export default LoginPage;
